import { SearchTerm } from "./SearchTerm";

const MessageSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "lmMessage",
        translationKey: "name"
    },
    {
        heading: "Site",
        accessor: "site",
        searchOnName: "site.siteName",
        translationKey: "site"
    },
];

export default MessageSearch;
